<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-button-goto ttText="new_external_api" ttGoto="externalapi" [ttGotoParms]="{ external_api_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="searchText" ttShowClearButton></tt-input>
        </tt-card>

        <tt-list [ttData]="itemsListExternalApis" [ttFilter]="searchText"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="searchText" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="new_external_api" ttGoto="externalapi" [ttGotoParms]="{ external_api_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListExternalApis" [ttFilter]="searchText"></tt-list>
    </div>
</tt-page>
